<script type="text/babel">
export default{
  data () {
    return {}
  },
  mounted () {
    alert("Test #3");
  },
  props: [],
  computed: {
  },
  methods: {}
}
</script>
